module.exports = __webpack_public_path__ + "static/media/icon_book-draft.b0fd0661.svg";